"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/es/modal/style");
var _modal = _interopRequireDefault(require("antd/es/modal"));
require("antd/es/statistic/style");
var _statistic = _interopRequireDefault(require("antd/es/statistic"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Login = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Login"));
var _logging = _interopRequireDefault(require("cornerstone_ui_core/lib/services/logging.service"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  Countdown
} = _statistic.default;
class App extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "clearTimeout", () => {
      if (this.warnTimeout) clearTimeout(this.warnTimeout);
    });
    _defineProperty(this, "resetTimeout", () => {
      if ((0, _lodash.isEmpty)(this.warningModal)) {
        this.clearTimeout();
        this.eventTriggered();
        this.setTimeout();
      }
    });
    _defineProperty(this, "eventTriggered", () => {
      localStorage.setItem("tab-active", "tab-active" + Math.random());
    });
    _defineProperty(this, "warn", () => {
      if ((0, _lodash.isEmpty)(this.warningModal)) {
        this.warningModal = _modal.default.warning({
          title: "Warning",
          content: /*#__PURE__*/_react.default.createElement("div", null, "You will be logged out automatically in", /*#__PURE__*/_react.default.createElement(Countdown, {
            title: "",
            value: Date.now() + 1000 * 60 * 5,
            onFinish: this.logout,
            format: "mm:ss"
          })),
          onOk: () => {
            this.closeTimeOutWindow();
            this.resetTimeout();
          },
          onCancel: () => {
            this.closeTimeOutWindow();
            this.resetTimeout();
          }
        });
      }
    });
    _defineProperty(this, "logout", () => {
      //clear localStorage
      sessionStorage.clear();
      localStorage.removeItem("sessionId");
      localStorage.removeItem("jwtToken");
      // Send a logout request to the API

      if (localStorage.getItem("AppId") === "SCS" || localStorage.getItem("AppId") === "RDS") {
        this.loginModalOpen = true;
        this.closeTimeOutWindow();
        this.resetTimeout();
        return this.loginModal.open().then(() => {
          this.loginModalOpen = false;
          this.setTimeout();
        }).catch(err => console.log(err));
      }
      this.props.logout && this.props.logout();
      this.destroy(); // Cleanup
    });
    _defineProperty(this, "closeTimeOutWindow", () => {
      if (!(0, _lodash.isEmpty)(this.warningModal)) {
        this.warningModal.destroy();
        this.warningModal = "";
        if (localStorage.getItem("AppId") !== "FEP") (0, _logging.default)("Timeout canceled", "INFO");
      }
    });
    _defineProperty(this, "destroy", () => {
      this.clearTimeout();
      !(0, _lodash.isEmpty)(this.warningModal) && this.warningModal.destroy();
      localStorage.removeItem("logout-event");
      localStorage.removeItem("logout-triggered");
      window.removeEventListener("storage", this.logoutAfterTimeout);
      for (var i in this.events) {
        window.removeEventListener(this.events[i], this.resetTimeout);
      }
    });
    _defineProperty(this, "logoutAfterTimeout", (event, that) => {
      if (event.key === "tab-active") {
        //Avoid time out if another window is active
        this.closeTimeOutWindow();
        this.clearTimeout();
        this.setTimeout();
        localStorage.removeItem("tab-active");
      }
      if (event.key === "logout-triggered") {
        that.props.logout && that.props.logout();
      }
    });
    this.events = ["load", "mousemove", "mousedown", "click", "scroll", "keypress"];
    this.state = {};
  }
  componentDidMount() {
    this.init();
    if (localStorage.getItem("loginModalOpen")) {
      this.logout();
    }
  }
  init() {
    this.warningModal = "";
    this.setTimeout = this.setTimeout.bind(this);
    for (var i in this.events) {
      window.addEventListener(this.events[i], this.resetTimeout);
    }
    window.addEventListener("storage", event => this.logoutAfterTimeout(event, this));
    this.setTimeout();
  }
  componentWillUnmount() {
    this.destroy(); // Cleanup
  }

  setTimeout() {
    if (!this.loginModalOpen) {
      const storedTimeout = localStorage.getItem("timeout");
      const timeout = storedTimeout ? storedTimeout : 15;
      this.warnTimeout = setTimeout(this.warn, (timeout - 5) * 60 * 1000);
    }
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Login.default, _extends({
      key: 1,
      modalProps: {
        className: "promise-modal",
        title: "Login",
        closable: false,
        maskClosable: false
      }
    }, this.props, {
      ref: ref => this.loginModal = ref
    })), children);
  }
}
exports.default = App;